import axiosClient from "@/api/common/axiosClient.ts";
import { AuthenticationResponse } from "@/types/authentication.ts";

export const signIn = ({
  email,
  password,
  remember_me = true,
  reactivation = false,
}: {
  email: string;
  password: string;
  remember_me?: boolean;
  reactivation?: boolean;
}) => {
  return axiosClient.post<AuthenticationResponse>("users/sign_in/", {
    email,
    password,
    remember_me,
    is_staff: false,
    reactivation,
  });
};

export type SignInErrorType = {
  detail: string;
};
